export default {
    public:{
        subject:'เรื่อง',
        author:'ผู้เขียน',
        select: 'กรอง',
        item:'รายการ',
        keywords:'คำสำคัญ',
        load:'กำลังโหลด...',
        nodata:'ไม่มีข้อมูล',
        close:'ปิด',
        all:'ทั้งหมด',
        cancel:'ยกเลิก',
        traditionalChinese:'จีนดั้งเดิม',
        thai:'ภาษาไทย',
        indonesian:'อินโดนีเซีย',
        malay:'ภาษามาเลย์',
        filipino:'ภาษาฟิลิปปินส์',

        successful:'ความสำเร็จในการลงทะเบียน',
        loginTips: 'กรุณาเข้าสู่ระบบบัญชีส่วนตัวของคุณ',
        loginSuccess: 'เข้าสู่ระบบเรียบร้อยแล้ว',
        library:'ChatAnswer ระบบอ้างอิง AI ของห้องสมุด',
        fellows:'ChatFellows ระบบการค้นพบ/การอ้างอิงเพียร์ภายในสถาบัน',
        research:'ChatResearch แพลตฟอร์มการวิจัยทางวิชาการที่มีประสิทธิภาพสูงและปรับแต่งได้เอง',
        language:'ChatLanguage การแปลอัจฉริยะ AI หลายภาษาและระบบพิสูจน์อักษรไวยากรณ์',
        document:'ChatDocuments เครื่องมือแยกวิเคราะห์เอกสารแบบลึก',
        data:'ChatData ตัวแยกวิเคราะห์ตารางข้อมูลลึก',
        other:'อื่น',
        feedSuccess:'ข้อเสนอแนะปัญหาสำเร็จ!',
        codeTips:'รหัสยืนยันถูกส่งไปแล้ว โปรดตรวจสอบอย่างละเอียด',
        overtime:'คำขอหมดเวลา'	
    },
    header:{
        feedback:'ข้อเสนอแนะ',
        quit:'ล้มเลิก',
        personal:'เข้าสู่ระบบบัญชีส่วนตัว',
      
        language:'ภาษาเอาท์พุต',
        username:'ชื่อผู้ใช้',
        password:'รหัสผ่าน',
        log:'เข้าสู่ระบบ',
        noRegistered:'ไม่มีบัญชีที่ลงทะเบียน',
        register:'ลงทะเบียน',
        personalAccount:'ลงทะเบียนบัญชีส่วนตัว',
        accountUsername:'บัญชี/ชื่อผู้ใช้',
        tips:'กรุณากรอกบัญชี/ชื่อผู้ใช้',
        tipsPassword:'กรุณากรอกรหัสผ่าน',
        confirmPassword:'ยืนยันรหัสผ่าน',
        tipsConfirmPassword:'กรุณายืนยันรหัสผ่านอีกครั้ง',
        email:'จดหมาย',
        tipsEmail:'กรุณากรอกอีเมล์ของคุณ',
        phone:'หมายเลขโทรศัพท์',
        tipsPhone:'กรุณากรอกหมายเลขโทรศัพท์',
        verificationCode:'รหัสยืนยันโทรศัพท์มือถือ',
        tipsVerificationCode:'กรุณากรอกรหัสยืนยันโทรศัพท์มือถือ',
        sendVerificationCode:'รับ',
        back:'กลับ',
        module:'โมดูลการทำงาน',
        selectTip:'โปรดเลือกโมดูลการทำงานที่มีปัญหา',
        question:'คำอธิบายปัญหา',
        screenshot:'ภาพหน้าจอของปัญหา',
        upload:'คลิกเพื่ออัพโหลด',
        type:'รองรับการอัปโหลดรูปแบบ .jpg/.png เท่านั้น',
        passwordTip:'กรุณากรอกรหัสผ่าน 6-24 หลัก',
        enterAgain:'กรุณากรอกรหัสผ่านอีกครั้ง',
        inconsistent:'รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน!',
        enterCode:'กรุณากรอกรหัสยืนยัน',
        emailTip:'กรุณากรอกที่อยู่อีเมลที่ถูกต้อง',
        enterEmail:'กรุณากรอกที่อยู่อีเมล',
        otherQuestion:'คุณมีคำถามอื่นที่คล้ายกับปัญหานี้หรือไม่',
        example:'ตัวอย่างเช่น',
        bibliography:'บรรณานุกรมห้องสมุด',
        logOut:'คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบบัญชีของคุณ',
        sure:'แน่นอน',
        switching:'เปลี่ยนไปใช้หลายภาษาได้สำเร็จ',
        again:'ส่งอีกครั้งหลังจากผ่านไป',
        again2:'วินาที',
        hello:'สวัสดี'
    },
    login:{
        log:'เข้าสู่ระบบ',
        institutionalLogin:'เข้าสู่ระบบสถาบัน',
        personalLogin:'เข้าสู่ระบบส่วนบุคคล',
        accountRegistration:'ลงทะเบียนบัญชี',
        retrievePassword:'ดึงรหัสผ่าน',
        usernameTip:'กรุณากรอกชื่อผู้ใช้องค์กรของคุณ',
        personal:'กรุณากรอกชื่อผู้ใช้ส่วนตัวของคุณ',
        forget:'ลืมรหัสผ่านเหรอ?',
        ipLog:'เข้าสู่ระบบไอพี',
        institutional:'กลไก',
        institutionalTip:'กรุณาเลือกสถาบัน',
        country:'ชาติ',
        countryTip:'โปรดเลือกประเทศ',
        invitationCode:'รหัสการเชิญ',
        codeTip: 'กรุณากรอกรหัสเชิญ',
        newPass:'รหัสผ่านใหม่',
        newPassTip:'กรุณากรอกรหัสผ่านใหม่',
        elmaiCode:'รหัสยืนยันอีเมล',
        elmaiTip:'กรุณากรอกรหัสยืนยันอีเมล์',
        resetting:'รีเซ็ตรหัสผ่าน',
        logTip: 'ชื่อผู้ใช้ขององค์กรต้องไม่เว้นว่าง',

        truePhone:'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
        successful:'การลงทะเบียนบัญชีสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง!',
        passwordReset:'รีเซ็ตรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง!',

        noteTitle:'หมายเหตุในการรับรหัสยืนยัน:',
        noteOne:'1. เพื่อให้แน่ใจว่าสามารถส่งรหัสยืนยันได้ทันเวลาและแม่นยำ เราขอแนะนำให้ใช้ผู้ให้บริการอีเมลต่อไปนี้: Gmail, Outkook, Yahoo;',
        noteTwo:'2. เนื่องจากกลไกการกรองของผู้ให้บริการอีเมลแต่ละราย บางครั้งอีเมลรหัสยืนยันอาจถูกตัดสินว่าเป็นสแปมหรืออีเมลไม่ถูกต้อง โปรดตรวจสอบว่าอีเมลรหัสยืนยันอยู่ในถังรีไซเคิลสแปมหรือไม่',
    },
    chatlibrary:{
        questionOne: 'สอบถามปัญหาการยืมห้องสมุด',
        questionTwo:'สอบถามเกี่ยวกับปัญหาที่เกี่ยวข้องกับฐานข้อมูลที่จัดซื้อ',
        questionThree:'สอบถามเกี่ยวกับประเด็นที่เกี่ยวข้องกับทรัพยากรดิจิทัลของห้องสมุด',
        quickAccess: 'เข้าถึงได้รวดเร็ว',
        disclaimer:'ข้อสงวนสิทธิ์',
        further:'คำถามเพิ่มเติม',
        goon:'ดำเนินการต่อ',
        statementOne:'1. เนื้อหาตอบกลับของ ChatAnswer อิงจากการตอบคำถามที่พบบ่อยและข้อมูลสาธารณะเกี่ยวกับแหล่งข้อมูลที่เกี่ยวข้อง เนื้อหาจริงขึ้นอยู่กับข้อมูลอย่างเป็นทางการที่เผยแพร่โดยห้องสมุดและเนื้อหาอย่างเป็นทางการของแหล่งข้อมูลต้นทาง',
        statementTwo:'2.ผลการแปลของฟังก์ชันการแปลมีไว้เพื่อการอ้างอิงเท่านั้น แพลตฟอร์มไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดจากการอาศัยความถูกต้องหรือความน่าเชื่อถือของข้อมูลการแปลของเว็บไซต์ เนื้อหาในการแปลเป็นเพียงมุมมองของต้นฉบับเท่านั้น ผู้เขียน และไม่ได้เป็นตัวแทนมุมมองและความคิดเห็นของแพลตฟอร์ม ไม่เกี่ยวข้องกับตำแหน่งของผู้พัฒนาแพลตฟอร์ม',
        statementThree:'3. ฟังก์ชั่นการพิสูจน์อักษรไวยากรณ์จะตรวจสอบเฉพาะปัญหาทางภาษาและไวยากรณ์ของเนื้อหาเท่านั้นและไม่สามารถเข้าถึงระดับการขัดเกลาภาษาเทียมได้ แพลตฟอร์มจะไม่รับผิดชอบต่อการสูญเสียใด ๆ ที่เกิดจากการพึ่งพาผลการพิสูจน์อักษรไวยากรณ์มากเกินไป',
        statementFour:'4. หากผู้อ่านส่งบทความไปยังสิ่งพิมพ์ตามผลคำแนะนำที่คล้ายคลึงกันพวกเขาจะต้องยืนยันข้อมูลปัญหาและติดต่อแผนกบรรณาธิการก่อนที่จะส่ง เราจะไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดจากการพึ่งพาข้อมูลที่จัดทำโดยเว็บไซต์โดยไม่ตั้งใจ',
        statementFive:'5. ความคิดเห็นที่แสดงในคำถาม ข้อกำหนดในการค้นหา ข้อความ และไฟล์ที่ผู้อ่านอัปโหลดไม่ได้แสดงถึงมุมมองและความคิดเห็นของแพลตฟอร์ม และไม่มีส่วนเกี่ยวข้องกับตำแหน่งของผู้พัฒนาแพลตฟอร์ม',
        // 手机端
        statementOneMobile:'1. เนื้อหาตอบกลับของ ChatAnswer อิงจากการตอบคำถามที่พบบ่อยและข้อมูลสาธารณะเกี่ยวกับแหล่งข้อมูลที่เกี่ยวข้อง เนื้อหาจริงขึ้นอยู่กับข้อมูลอย่างเป็นทางการที่เผยแพร่โดยห้องสมุดและเนื้อหาอย่างเป็นทางการของแหล่งข้อมูลต้นทาง',
        statementTwo:'2.ผลการแปลของฟังก์ชันการแปลมีไว้เพื่อการอ้างอิงเท่านั้น แพลตฟอร์มไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดจากการอาศัยความถูกต้องหรือความน่าเชื่อถือของข้อมูลการแปลของเว็บไซต์ เนื้อหาในการแปลเป็นเพียงมุมมองของต้นฉบับเท่านั้น ผู้เขียน และไม่ได้เป็นตัวแทนมุมมองและความคิดเห็นของแพลตฟอร์ม ไม่เกี่ยวข้องกับตำแหน่งของผู้พัฒนาแพลตฟอร์ม',
        statementThree:'3. ฟังก์ชั่นการพิสูจน์อักษรไวยากรณ์จะตรวจสอบเฉพาะปัญหาทางภาษาและไวยากรณ์ของเนื้อหาเท่านั้นและไม่สามารถเข้าถึงระดับการขัดเกลาภาษาเทียมได้ แพลตฟอร์มจะไม่รับผิดชอบต่อการสูญเสียใด ๆ ที่เกิดจากการพึ่งพาผลการพิสูจน์อักษรไวยากรณ์มากเกินไป',
        statementFour:'4. หากผู้อ่านส่งบทความไปยังสิ่งพิมพ์ตามผลคำแนะนำที่คล้ายคลึงกันพวกเขาจะต้องยืนยันข้อมูลปัญหาและติดต่อแผนกบรรณาธิการก่อนที่จะส่ง เราจะไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดจากการพึ่งพาข้อมูลที่จัดทำโดยเว็บไซต์โดยไม่ตั้งใจ',
        statementFive:'5. ความคิดเห็นที่แสดงในคำถาม ข้อกำหนดในการค้นหา ข้อความ และไฟล์ที่ผู้อ่านอัปโหลดไม่ได้แสดงถึงมุมมองและความคิดเห็นของแพลตฟอร์ม และไม่มีส่วนเกี่ยวข้องกับตำแหน่งของผู้พัฒนาแพลตฟอร์ม',
        // 进入弹窗文本
        hellow:'สวัสดี: ยินดีต้อนรับคำปรึกษาของคุณ ฉันเป็นใคร',
        introduceOne:' ChatAnswer ผู้ช่วย AI อัจฉริยะยินดีให้บริการคุณ',
        introduceTwo:'1. เวลาเปิดทำการของห้องสมุด',
        introduceThree:'2. จะหาแหล่งข้อมูลดิจิทัลได้อย่างไร?',
        introduceFour:'3. หากหนังสือที่ยืมมาสูญหายโดยไม่ได้ตั้งใจควรทำอย่างไร?',
        introduceFive:'4. แนะนำฐานข้อมูลที่เกี่ยวข้องกับการแพทย์',
        introduceSix:'5. ฉันจะเข้าถึงทรัพยากรดิจิทัลของห้องสมุดนอกวิทยาเขตได้อย่างไร',
        introduceSeven:'คุณสามารถถามคำถามเกี่ยวกับห้องสมุดได้ เช่น ถามฉันว่า "จะตรวจสอบและค้นหาหนังสือที่คุณต้องการได้อย่างไร" "เวลาทำการของห้องสมุด" "กฎการยืมหนังสือ" ฯลฯ ฉันจะพยายามตอบคุณให้ดีที่สุด และเกี่ยวกับ เรายังตอบคำถามเกี่ยวกับหนังสือ ฐานข้อมูล และบริการห้องสมุดอื่นๆ ได้อีกด้วย เช่น',
        questions: 'คำถามเพิ่มเติม',
        Continue:'ดำเนินการต่อ',
        recording:'บันทึกการคลิกเมาส์',
        stopRecording:'คลิกเมาส์เพื่อหยุดการบันทึก',
        microphone:'โปรดอนุญาตให้เพจนี้ใช้ไมโครโฟนก่อน',
        browserTips:'เบราว์เซอร์ของคุณไม่รองรับการรู้จำเสียง',
        browserTips2:'เบราว์เซอร์ของคุณไม่รองรับการรู้จำระดับเสียง',
        progress:'อยู่ระหว่างการรู้จำเสียง...',
        failed:'การจดจำเสียงล้มเหลว',
    },
    chatresearch:{
        theme:'ChatResearch | การค้นพบความลึกความหมาย',
        themeMobile:'การค้นพบความลึกความหมาย',
        switchSemantics:'การสลับการค้นหาภาษา',
        switchTraditional: 'เปลี่ยนการค้นหาแบบดั้งเดิม',
        title: 'ชื่อ',
        results:'ผลลัพธ์ที่โดดเด่น',
        year:'สำนักพิมพ์',
        abstract:'สรุป',
        tips:'กรุณากรอกเนื้อหาการค้นหา ...',
        select:'กรุณาเลือก',
        issn:'ISSN',
        introduce_tit:'การแนะนำแพลตฟอร์ม',
        introduceOne:'ChatResearch จะใช้ปัญญาประดิษฐ์และเทคโนโลยีขั้นสูงเพื่อให้ผู้อ่านได้รับแพลตฟอร์มการวิจัยทางวิชาการที่ครอบคลุม เป็นส่วนตัว และมีประสิทธิภาพมากขึ้น คุณสมบัติหลักได้แก่:',
        introduceTwo:'ระบบค้นหาความหมายข้ามภาษา: ด้วยความเข้าใจเชิงลึกเกี่ยวกับความตั้งใจและความสนใจในการค้นหาของผู้อ่าน ตลอดจนกราฟความรู้ข้ามภาษา ระบบค้นหาความหมายข้ามภาษาของแพลตฟอร์ม ChatResearch จะให้ผลการค้นหาที่ครอบคลุมและแม่นยำยิ่งขึ้น',
        introduceThree:'การจัดการเอกสารเป็นชุด: เครื่องมือการจัดการเอกสารเป็นชุดสามารถช่วยให้นักวิจัย นักวิชาการ และกลุ่มอื่นๆ ประมวลผลเนื้อหาเอกสารจำนวนมากได้อย่างรวดเร็ว พวกเขาสามารถใช้การจัดหมวดหมู่ คำอธิบายประกอบ การค้นหา การกรอง คำอธิบายประกอบ การดาวน์โหลด และฟังก์ชันอัตโนมัติที่หลากหลาย ซึ่งช่วยปรับปรุงการจัดการเอกสารและประสิทธิภาพการวิจัยทางวิทยาศาสตร์อย่างมาก',
        search:'การค้นหาเชิงตรรกะแบบดั้งเดิม',
        searchAll:'ค้นหาทั้งหมด',
        searchTip:'คุณสามารถใช้ข้อความแบบเต็มของบทคัดย่อ ย่อหน้าจากวรรณกรรม หรือข้อความคำอธิบายโดยละเอียดเป็นเนื้อหาการค้นหา ระบบสามารถใช้การดึงความหมายตามการเปรียบเทียบความคล้ายคลึงทางความหมาย ยิ่งเนื้อหาอินพุตยาวเท่าใด เอฟเฟกต์การจับคู่ก็จะยิ่งแม่นยำมากขึ้นเท่านั้น',
        clear:'ล้างการค้นหา',
        link:'ลิงค์บทความ',
        Similar:'เอกสารที่คล้ายกัน',
        followingresults:'ค้นหาในผลการค้นหาต่อไปนี้',
        chinese:'ภาษาจีนกลาง',
        english:'ภาษาอังกฤษ',
        total:"ส่งกลับจำนวนผลลัพธ์ทั้งหมด",
        introduceFour:'ระบบการค้นพบหัวเรื่องโดยอาศัยการวิเคราะห์เชิงความหมายและการจับคู่ความคล้ายคลึง ซึ่งสามารถดึงข้อมูลข้ามภาษาได้อย่างมีประสิทธิภาพและชาญฉลาด',
        volume:'กรุณาเลือกปริมาณการค้นหา',
        
        inputTips:'เนื้อหาของช่องป้อนข้อมูลปัจจุบันต้องไม่ว่างเปล่า!'
    },
    chatlanguage: {
        enter: 'เข้า',
        errorChecking:'ค้นหาข้อผิดพลาดทางไวยากรณ์ในภาษาอังกฤษ',
        CToE: 'จีนเป็นอังกฤษ',
        EToC: 'ภาษาอังกฤษเป็นภาษาจีน',
        docTran: 'แปลเอกสารแปล',
        functionIntroduction: 'คุณสมบัติ',
        introduceOne: 'คุณสามารถใช้ฟังก์ชัน "ค้นหาข้อผิดพลาดไวยากรณ์ภาษาอังกฤษ" เพื่อทำการพิสูจน์อักษรไวยากรณ์อัจฉริยะของเนื้อหาข้อความภาษาอังกฤษ หลังจากป้อนเนื้อหาแล้ว ระบบสามารถระบุและแก้ไขปัญหาไวยากรณ์ในบทความได้อย่างชาญฉลาด รองรับการแก้ไขโครงสร้างประโยค กาล การใช้หัวเรื่องและภาคแสดง เครื่องหมายวรรคตอน และปัญหาประเภทอื่น ๆ ช่วยปรับปรุงคุณภาพของบทความและเพิ่มความสามารถในการอ่าน และความแม่นยำในการแสดงออก',
        introduceTwo: 'คุณสามารถใช้ฟังก์ชัน "English Academic Polishing" เพื่อขัดเกลาและปรับข้อความภาษาอังกฤษให้เหมาะสมได้ ระบบจะปรับเปลี่ยนข้อความจากมุมมองของความคล่องแคล่วและความสง่างามเพื่อให้เรียบและกระชับยิ่งขึ้น เพิ่มเสน่ห์แบบมืออาชีพให้กับข้อความและทำให้แนวคิดธีมปรากฏชัดเจนยิ่งขึ้น',
        tips: 'กรุณากรอกเนื้อหาแบบสอบถาม',
        basic:'ฟังก์ชั่นพื้นฐาน',
        polish:'โปแลนด์เชิงวิชาการภาษาอังกฤษ',
        inputTips:'โปรดป้อนเนื้อหาข้อความที่ต้องมีการพิสูจน์อักษรหรือขัดเกลา',

        againRequest:'คำขอล้มเหลว โปรดลองอีกครั้ง',
    },
    chatfellows:{
        introduceOne:'ความสำเร็จ แพลตฟอร์มการค้นพบอัจฉริยะ——ยืนอยู่บนไหล่ของรุ่นก่อน',
        introduceTwo:'การแนะนำแพลตฟอร์ม',
        introduceThree_one:'แชทเฟลโลว์',
        introduceThree_two:'Achievements Intelligent Discovery Platform เป็นเครื่องมือดึงข้อมูลทางวิชาการอัจฉริยะที่สร้างขึ้นสำหรับนักวิจัยของ ',
        introduceThree:'โดยเฉพาะ จากการบูรณาการผลลัพธ์ของสถาบันอย่างครอบคลุม การคำนวณความคล้ายคลึงทางความหมาย เทคโนโลยีเวกเตอร์ไดเซชัน การรับรู้ภาษาธรรมชาติ และเทคโนโลยีอื่นๆ ถูกนำมาใช้เพื่อให้บรรลุการใช้ผลลัพธ์ในเชิงลึกและหลายมิติ บรรลุการจับคู่ผลลัพธ์ที่ชาญฉลาดและแม่นยำ การเรียงลำดับความคล้ายคลึง และตระหนักถึงข้าม -การดึงข้อมูลและการจับคู่ภาษา ช่วยเหลือนักวิจัยทางวิทยาศาสตร์อย่างมีประสิทธิภาพในการดำเนินการวิจัยทางวิทยาศาสตร์และงานเขียน เช่น การวิจัยวรรณกรรมเชิงวิชาการ การสืบค้นข้อมูลอ้างอิง และการคัดเลือกวารสาร',
        introduceFour:'Achievements Intelligent Discovery Platform ได้รับการบูรณาการอย่างสมบูรณ์และรวบรวมผลการวิจัยที่สำคัญของโรงเรียนของเรา การประยุกต์ใช้เทคโนโลยี AI อัจฉริยะในเชิงลึกทำให้สามารถประยุกต์ใช้ผลลัพธ์ได้อย่างมีประสิทธิภาพและช่วยในการพัฒนางานวิจัยทางวิทยาศาสตร์อย่างมีประสิทธิผล มีความมุ่งมั่นที่จะช่วยให้ผู้ใช้ค้นหาเอกสารคุณภาพสูงในสาขาที่เกี่ยวข้องได้อย่างรวดเร็วและแม่นยำ ปรับปรุงประสิทธิภาพการวิจัย และช่วยให้บรรลุผลการเรียน ยืนบนไหล่ของยักษ์ใหญ่และส่งเสริมความก้าวหน้าของการวิจัยทางวิชาการอย่างต่อเนื่อง',
        introduceFive:'ฟังก์ชั่นหลัก',
        introduceSix:'การเรียกค้นการจับคู่อัจฉริยะ:ตระหนักถึงการค้นพบเอกสารที่คล้ายกันอย่างมีประสิทธิภาพในผลลัพธ์แหล่งการประเมินที่สำคัญของโรงเรียนของเรา',
        introduceSeven:'การเรียกค้นข้ามภาษา:ด้วยการประยุกต์ใช้เทคโนโลยี vectorization การเรียกค้นและการจับคู่สามารถทำได้โดยไม่มีข้อจำกัดทางภาษา',
        introduceTen:'การเรียงลำดับการเพิ่มประสิทธิภาพความคล้ายคลึงกัน:ผลลัพธ์การจับคู่ที่เหมาะสมที่สุดจะถูกนำเสนอโดยพิจารณาจากความคล้ายคลึงกันของงานวิจัยทำให้ผู้อ่านทางวิทยาศาสตร์สามารถค้นหาผลการวิจัยที่เกี่ยวข้องมากที่สุดได้อย่างรวดเร็วยิ่งขึ้น',
        introduceEight:'การแสดงข้อมูลโดยละเอียด:แพลตฟอร์มนี้ให้ข้อมูลวรรณกรรมโดยละเอียดของผลการค้นหาและคำแปลสรุปของผลลัพธ์ภาษาต่างประเทศทำให้ผู้ใช้สามารถเข้าใจสาระสำคัญของผลลัพธ์ได้อย่างรวดเร็ว',
        introduceNine:'การอัปเดตทันเวลาสูง:แพลตฟอร์มจะซิงโครไนซ์ฐานข้อมูลแหล่งการประเมินที่สำคัญเป็นประจำเพื่อให้แน่ใจว่าผู้อ่านสามารถเข้าใจผลลัพธ์ล่าสุดได้',
        knowBtn:'ฉันเห็น',
        enter:'เข้า',
        title:'ความสำเร็จ แพลตฟอร์มการค้นพบอัจฉริยะ——ยืนอยู่บนไหล่ของรุ่นก่อน',
        tips:'กรุณากรอกบทคัดย่อหรือหัวข้อของบทความที่คุณต้องการค้นหา (ชื่อเรื่อง คำสำคัญ ฯลฯ) และระบบจะช่วยคุณค้นหาเอกสารที่คล้ายกันจากโรงเรียนของเราในแหล่งประเมินที่สำคัญ (ไม่จำเป็นต้องมีการแปลและการแปลงเป็นพิเศษสำหรับภาษาจีน !)',
        submit:'ส่ง',
        relatedLiterature:'วรรณกรรมที่เกี่ยวข้อง',
        year:'ปี',

        enSummary:'สรุปภาษาอังกฤษ',
        cnSummary:'สรุปภาษาจีน.',
    },
    chatdocument:{
        title:'เครื่องมือแยกวิเคราะห์เอกสารเชิงลึก',
        introduce:'ตระหนักถึงการแยกเนื้อหาข้อมูลเอกสารและการวิเคราะห์ข้อความแบบเต็มของหัวข้อและขอบเขตที่ระบุ ซึ่งช่วยในการวิจัยเชิงลึก',
        start:'เริ่มประสบ',
        ask:'ถามคำถามเกี่ยวกับเอกสารและรับคำตอบที่คุณต้องการ',
        createSession:'สร้างการสนทนาและถามคำถามในเอกสารหลายฉบับพร้อมกัน',
        quoting:'การอ้างอิงข้อความและการวิเคราะห์เชิงลึกของเนื้อหาวรรณกรรม',
        analyze:'วิเคราะห์แผนภูมิและดึงข้อมูลเพื่อการวิเคราะห์ที่ครอบคลุม',
        tool:"ผู้ช่วยแยกวิเคราะห์เอกสารประสิทธิภาพสูง",
        list:'รายการวรรณกรรม',
        conversation:'รายการสนทนา',
        createAsk:'การสร้างวาระงาน',
        upload:'อัปโหลดไฟล์',
        drag:'ลากไฟล์เข้ามาหรือคลิกเพื่ออัปโหลด',
        introduceOne:'ถามคำถามเกี่ยวกับเนื้อหาเอกสารและรับคำตอบทันทีผ่านการแชท',
        introduceTwo:'ChatDocuments เป็นตัวช่วยในการแยกวิเคราะห์ไฟล์ที่สามารถแยก ค้นหา และสรุปข้อมูลจากเอกสารได้อย่างรวดเร็ว',
        quick:'เข้าถึงได้รวดเร็ว',
        enter:'กรุณากรอกเนื้อหา...',
        askQuestion:'ถามคำถาม',
        example:'ตัวอย่าง',
        busy:'บริการไม่ว่างโปรดลองอีกครั้ง',
        stop:'หยุดตอบ',
        onlyAsk:'ถามคำถามเกี่ยวกับบทความปัจจุบันเท่านั้น',
        chapter:'บท',
        create:'สร้าง',
        editsession:'แก้ไขเซสชัน',
        sessionname:'ชื่อเซสชัน',
        currentlyselected:'ที่เลือกอยู่ในปัจจุบัน',
        fileselection:'การเลือกไฟล์',
        revise:'ปรับปรุง',
        docLanguage:'ภาษาเอกสาร',
        zhDoc:'เอกสารภาษาจีน',
        enDoc:'เอกสารภาษาอังกฤษ',
        support:'*รองรับการอัพโหลดไฟล์ PDF เท่านั้น',
        nowUpload:'กำลังอัพโหลด กรุณารอสักครู่...',
        question:'ภาษาของเอกสารไม่ตรงกันและไม่สามารถเลือกได้',
        editTitle:'ดับเบิลคลิกเพื่อแก้ไขชื่อไฟล์',

        uploadSuccess:'อัปโหลดสำเร็จ',
        sideBar:'ย่อแถบด้านข้าง',
        noData:'ไม่พบตารางแยกวิเคราะห์ในเอกสาร',
        delConfirm:'คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้',
        unable:'แยกวิเคราะห์ Excel ไม่ได้',
        delSuccess:'ลบเรียบร้อยแล้ว',
        selFile:'กรุณาเลือกไฟล์',
        inputName:'กรุณากรอกชื่อเซสชั่น',
        createSuccess:'สร้างสำเร็จแล้ว',
        fileTips:'ไฟล์กำลังถูกแปลง กรุณาลองใหม่อีกครั้งในภายหลัง',
        failFile:'การแปลงไฟล์ล้มเหลว โปรดอัปโหลดอีกครั้ง',
        defaultQuestion1:'ตารางมีฟิลด์ใดบ้างและข้อมูลใดบ้างที่อธิบายไว้',
        defaultQuestion2:'โปรดคำนวณค่าเฉลี่ยของแต่ละคอลัมน์ของข้อมูลหรือไม่',
        defaultQuestion3:'กรุณาคำนวณค่ามัธยฐานของข้อมูลแต่ละคอลัมน์?',
        defaultQuestion4:'ค่าใดที่เกิดขึ้นบ่อยที่สุดในข้อมูลแต่ละคอลัมน์?',
        defaultQuestion5:'ข้อมูลใดบ้างที่เราได้จากข้อมูลในตาราง และเราได้ข้อสรุปอะไรจากการวิเคราะห์',
    },
    chatdata:{
        title:'เครื่องมือวิเคราะห์ข้อมูลเชิงลึก',
        introduce:'ค้นพบข้อมูลเชิงลึกจากข้อมูลของคุณผ่านการแยกวิเคราะห์อัจฉริยะและการวิเคราะห์เชิงลึก ใช้ฟังก์ชันการวิเคราะห์ด้วยภาพเพื่อให้ได้การแสดงผลที่ชัดเจนในรูปแบบของแผนภูมิ',
        start:'เริ่มประสบ',
        ask:'ถามคำถามเกี่ยวกับเอกสารและรับคำตอบที่คุณต้องการ',
        create:'สร้างการสนทนาและถามคำถามในเอกสารหลายฉบับพร้อมกัน',
        quoting:'การอ้างอิงข้อความและการวิเคราะห์เชิงลึกของเนื้อหาวรรณกรรม',
        analyze:'วิเคราะห์แผนภูมิและดึงข้อมูลเพื่อการวิเคราะห์ที่ครอบคลุม',
        tool:"ผู้ช่วยแยกวิเคราะห์เอกสารประสิทธิภาพสูง",
        list:'รายการวรรณกรรม',
        conversation:'รายการสนทนา',
        createAsk:'การสร้างวาระงาน',
        upload:'อัปโหลดไฟล์',
        drag:'ลากไฟล์เข้ามาหรือคลิกเพื่ออัปโหลด',
        introduceOne:'ChatData ช่วยให้สามารถตั้งคำถามเชิงสนทนากับตารางผ่านการวิเคราะห์ตารางและชุดข้อมูลอย่างชาญฉลาด และด้วยการวิเคราะห์เชิงลึก แผนภูมิภาพจะถูกสร้างขึ้นโดยอัตโนมัติเพื่อให้ข้อมูลมีความชัดเจนในทันที!',
        quick:'เข้าถึงได้รวดเร็ว',
        enter:'กรุณากรอกเนื้อหา...',
        hint:'คำใบ้',
        hintOne:'โมดูลนี้อยู่ระหว่างการบำรุงรักษาและไม่สามารถใช้งานได้ชั่วคราว ขอขอบคุณสำหรับความเข้าใจและความอดทนของคุณ',
        Isee:'ฉันเห็น',
    },
    chatopen:{
        title:'เครื่องมือค้นหาความรู้แบบเปิดของคุณ',
        switch:'เปลี่ยนไปใช้การค้นหาแบบเดิม',
        introduce:'รับและค้นพบผลการวิจัยทางวิทยาศาสตร์ล่าสุดในสาขาฟิสิกส์ คณิตศาสตร์ วิทยาการคอมพิวเตอร์ ปัญญาประดิษฐ์ สถิติ ฯลฯ และเข้าใจแนวโน้มการพัฒนา',
        features:'คุณสมบัติ',
        featureOne:'ใช้ปัญญาประดิษฐ์และเทคโนโลยีขั้นสูงเพื่อให้นักวิจัยทางวิทยาศาสตร์ได้รับประสบการณ์การค้นพบความรู้ที่มีประสิทธิภาพ ทรงพลัง และแม่นยำยิ่งขึ้น ChatOpen ใช้เทคโนโลยีการเรียกค้นความหมายเพื่อให้เกิดความเข้าใจในเชิงลึกเกี่ยวกับความตั้งใจในการค้นหา ความสนใจ และการทำแผนที่ข้ามภาษาของผู้อ่าน',
        featureTwo:'บูรณาการข้อมูลเมตาความรู้แบบเปิดขนาดใหญ่เพื่อให้ผู้อ่านทางวิทยาศาสตร์ได้รับผลการเรียนแบบโอเพ่นซอร์สหลายประเภท รวมถึงเอกสารการเข้าถึงแบบเปิด การพิมพ์ล่วงหน้า ฯลฯ เมื่อรวมกับการค้นพบเชิงความหมาย เราหวังว่าแหล่งข้อมูลเหล่านี้สามารถช่วยคุณส่งเสริมนวัตกรรมการวิจัยทางวิชาการและเชื่อมโยงคุณกับอนาคตที่เปิดกว้าง',
        translate:'แปลภาษา',
        clear:'ล้างตัวกรอง'
    },
    message:{
        authority: "ไม่มีสิทธิ์",
        upload: "รองรับเฉพาะรูปแบบ .jpg/.png เท่านั้น!",
        apply: "ส่งคำขอทดลองใช้งานแล้ว โปรดรออย่างอดทน!",
        delete: "คุณแน่ใจหรือว่าต้องการลบไฟล์นี้?",
        size: "ขนาดไฟล์ต้องไม่เกิน 20MB",
        wait: "กำลังดำเนินการ โปรดรอ"
    }
}